import script from "./StaffHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./StaffHeader.vue?vue&type=script&setup=true&lang=js"

import "./StaffHeader.vue?vue&type=style&index=0&id=459b2f58&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-459b2f58"]])

export default __exports__